const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const COLORS = {
  pink: '#FF69B4',
  green: '#39D98A', 
  blue: '#4DA8FF',
  orange: '#FF9D4D'
};

const LINE_NAMES = {
  pink: 'Rosa',
  green: 'Verde', 
  blue: 'Blu',
  orange: 'Arancione'
};

const INGREDIENTS_BY_LINE = {
  pink: ['Olio d\'oliva', 'Vitamina C', 'Acido Ialuronico', 'Germe di grano', 'Elastina'],
  green: ['Collagene marino', 'AHA', 'Cellule staminali', 'Caffeina', 'Burro di macadamia'],
  blue: ['Omega Blu', 'Proteine della seta', 'Rosa mosqueta', 'Proteine di soia', 'Estratto di lumaca'],
  orange: ['Estratto di Kygelia', 'Coenzima Q10', 'Octopeptide', 'Polipeptidi', 'Glicerina']
};

const LINE_IMAGES = {
  pink: '/images/jars/pink-crema_notte.webp',
  green: '/images/jars/green-crema_giorno.webp',
  blue: '/images/jars/blue-contorno_labbra.webp',
  orange: '/images/jars/orange-siero_antiage.webp'
};

const jarImage = (product) => `/images/jars/${product.line_color}-${product.product_type}.webp`;

const withAlpha = (hex, alpha) => {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
};

export { BACKEND_URL, API, COLORS, LINE_NAMES, INGREDIENTS_BY_LINE, LINE_IMAGES, jarImage, withAlpha };
